export default {
  subscribe: null,
  roomsSubscribe: null,
  roomsCursor: null,
  roomsPageLoaded: false,
  currentMessagesRoomId: null,
  roomMessagesCursor: null,
  roomMessagesPageLoaded: false,
  roomIds: [],
  rooms: [],
  roomMessages: [],
  roomsForFirstTime: true,
  roomMessagesForFirstTime: true,
  activeRoom: null
};
